import * as React from 'react';
const IconMessages = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    {...props}
    width={40}
    height={40}
  >
    <rect width={40} height={40} fill="#396DFF" rx={7} />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="M27.973 18.387v5.333c0 .347-.014.68-.054 1-.306 3.6-2.426 5.387-6.333 5.387h-.533c-.334 0-.654.16-.854.426l-1.6 2.134c-.706.946-1.853.946-2.56 0l-1.6-2.134c-.173-.226-.56-.426-.853-.426h-.533c-4.254 0-6.387-1.054-6.387-6.387v-5.333c0-3.907 1.8-6.027 5.387-6.334.32-.04.653-.053 1-.053h8.533c4.253 0 6.387 2.133 6.387 6.387Z"
    />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="M33.306 13.053v5.334c0 3.92-1.8 6.026-5.387 6.333.04-.32.054-.653.054-1v-5.333c0-4.254-2.134-6.387-6.387-6.387h-8.533c-.347 0-.68.013-1 .053.306-3.586 2.426-5.386 6.333-5.386h8.533c4.254 0 6.387 2.133 6.387 6.386Z"
    />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M21.995 21.667h.012M17.327 21.667h.012M12.66 21.667h.013"
    />
  </svg>
);
export default IconMessages;
